import { useState } from 'react';

function MissedCallsModal({ missedCalls, onClose }) {
  const [filter, setFilter] = useState('');

  const filtered = missedCalls?.filter(call => 
    call.caller_number?.includes(filter) || 
    call.disposition?.toLowerCase().includes(filter.toLowerCase())
  ) || [];

  if (!missedCalls) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      justifyContent: 'center', alignItems: 'center', zIndex: 1000,
      padding: '20px'
    }} onClick={onClose}>
      <div style={{
        background: 'white', borderRadius: 'var(--radius-lg)',
        padding: '24px', maxWidth: '900px', width: '100%',
        maxHeight: '85vh', overflow: 'auto', boxShadow: 'var(--shadow-lg)'
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div>
            <h2 style={{ margin: 0, color: 'var(--text-primary)', fontSize: '20px' }}>Missed Calls Detail</h2>
            <div style={{ fontSize: '13px', color: 'var(--text-muted)', marginTop: '4px' }}>
              {missedCalls.length} missed calls today
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <input
              type="text"
              placeholder="Filter by number..."
              value={filter}
              onChange={e => setFilter(e.target.value)}
              style={{
                padding: '8px 12px', border: '1px solid var(--border)',
                borderRadius: 'var(--radius-sm)', fontSize: '13px',
                fontFamily: 'inherit', width: '180px'
              }}
            />
            <button onClick={onClose} style={{
              background: 'var(--danger)', color: 'white', border: 'none',
              borderRadius: 'var(--radius-sm)', padding: '8px 16px',
              cursor: 'pointer', fontSize: '14px', fontWeight: '500',
              fontFamily: 'inherit'
            }}>Close</button>
          </div>
        </div>

        {filtered.length > 0 ? (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <thead>
              <tr style={{ backgroundColor: 'var(--primary)', color: 'white' }}>
                <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600' }}>Time</th>
                <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600' }}>Caller Number</th>
                <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600' }}>Ring Duration</th>
                <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((call, index) => (
                <tr key={index} style={{
                  backgroundColor: index % 2 === 0 ? '#f9fafb' : 'white',
                  borderBottom: '1px solid var(--border-light)'
                }}>
                  <td style={{ padding: '10px', color: 'var(--text-secondary)' }}>
                    {new Date(call.call_date).toLocaleString('en-ZA')}
                  </td>
                  <td style={{ padding: '10px', fontWeight: '500' }}>{call.caller_number}</td>
                  <td style={{ padding: '10px' }}>{call.ring_duration}s</td>
                  <td style={{ padding: '10px' }}>
                    <span style={{
                      padding: '2px 10px', borderRadius: '12px',
                      backgroundColor: 'var(--danger-light)', color: 'var(--danger)',
                      fontSize: '12px', fontWeight: '600'
                    }}>{call.disposition}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-muted)' }}>
            {filter ? 'No calls match your filter' : 'No missed calls today'}
          </div>
        )}
      </div>
    </div>
  );
}

export default MissedCallsModal;
